<template>
  <div id="topNav" v-if="global.screenWidth < 1125">
    <MobileNav :siteId="siteId">
      <slot></slot>
    </MobileNav>
  </div>
  <div id="topNav" v-else>
    <PrimaryNav :siteId="siteId">
      <slot></slot>
    </PrimaryNav>
  </div>
</template>

<script>
import PrimaryNav from "./PrimaryNav";
import MobileNav from "./MobileNav";
import { mapState } from "vuex";
export default {
  name: "TopNav",
  components: {
    PrimaryNav,
    MobileNav,
  },
  props: {
    siteId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#topNav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
}
</style>